import React, {useContext, useEffect} from 'react'
import { signout } from '../supabase/supabase'
import { redirect, useNavigate } from 'react-router'
import { GlobalContext } from '../context/GlobalContext'

export default function Logout() {
    const global = useContext(GlobalContext)
    const navigate = useNavigate()
    useEffect(() => {
        signout().then(() => {
            localStorage.removeItem("session")
            global.setSession(null)
            navigate('/')
        })
    }, [])
    

    return (
        <>
            Click <a href="/">here</a> if you are not redirected.
        </>
    )
}